import {
  SHARING_LOADING,
  SHARING_ERROR,

  SHARING_ADD,
  SHARING_UPDATE,
  SHARING_DELETE,
  SHARING_GET,
  SHARING_GET_FILTERS
} from "actions/sharing/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  filters: []
};

export default function (state = initialState, action) {
  let list,
    index;
  switch (action.type) {
    case SHARING_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case SHARING_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case SHARING_GET:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case SHARING_GET_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        filters: action.payload.content,
      };
    case SHARING_ADD:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      list.content.push(action.payload);
      return {
        ...state,
        loading: false,
        list
      };
    case SHARING_UPDATE:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      index = list.content.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        list.content[index] = action.payload;
      } else {
        list.content.push(action.payload);
      }
      return {
        ...state,
        loading: false,
        list
      };
    case SHARING_DELETE:

      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      index = list.content.findIndex(item => item.id === action.payload);
      if (index > -1) {
        list.content.splice(index, 1);
      }
      return {
        ...state,
        loading: false,
        list
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sharingReducer.js